import { Step, Stepper } from "@material-tailwind/react";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeaderTitle } from "../../../components/header/Header";
import Container from "../../../components/layout/Container";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PADDING_MAIN,
  STYLE_TAB,
} from "../../../utils/useStyle";

import { useBalanceStore } from "../../../_store/balanceStore";
import { useInsuranceStore } from "../../../_store/insuranceStore";
import { useRetireStore } from "../../../_store/retireStore";
import { sumCapitalInvest, sumDebtInvest } from "../../../functions/Balance/sumProperty";
import { SumDebtPersonalValue } from "../../../functions/Balance/sumValueBalance";
import { useUserStore } from "../../../_store/userStore";
import { MTButton } from "../../../components/button/MTButton";
import { defaultValue } from "../../../functions/main";
import { numberWithoutComma } from "../../balance/component/VIDrawerDebt.Main";
import ViewDisable_Final from "./VIDisable_Final";
import ViewDisable_StepOne from "./VIDisable_StepOne";
import ViewDisable_StepThree from "./VIDisable_StepThree";
import ViewDisable_StepTwo from "./ViDisable_StepTwo";
import {
  calculateRateDifference,
  PV,
  PV2,
  round,
} from "../../../utils/useFunctions";
import { HealthCheckPDF } from "../../../functions/pdfGenerateFunction/riskManagePDF";

const ViewDisableInsurance = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const [final, setFinal] = useState(false);
  const [isLastStep, setIsLastStep] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(false);
  const [firstLoading, setFirstLoading] = useState(true);
  const [reload, setReload] = useState(0);

  const insuranceData = useInsuranceStore((state) => state.insuranceData);
  const setInsuranceData = useInsuranceStore((state) => state.setInsuranceData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const retireData = useRetireStore((state) => state.retireData);
  const userData = useUserStore((state) => state.userData);

  const sumEpense =
    Number(insuranceData?.disabled_personal_expenses_saving || 0) +
    Number(insuranceData?.disabled_personal_expenses_tax || 0) +
    Number(insuranceData?.disabled_personal_expenses_life_fund || 0) +
    Number(insuranceData?.disabled_personal_expenses_social_insurance || 0);

  useEffect(() => {
    // if (!firstLoading) return;
    let localInsuranceData = { ...insuranceData };
    let disabled_income_salary = 0;
    let disabled_income_bonus = 0;
    // เงินออมทั้งปี = sum_expenses_invest_saving (ตรงกับ Login.Main.js เลิก hardcode 0 ที่ clobber ค่า)
    let disabled_personal_expenses_saving = Number(
      balanceData?.sum_expenses_invest_saving || 0
    );
    let disabled_personal_expenses_tax = 0;
    let disabled_personal_expenses_life_fund = 0;
    let disabled_personal_expenses_social_insurance = 0;
    // let sum_disabled_insurance_current = 0;
    let disabled_asset_all = 0;
    let age =
      new Date().getFullYear() - new Date(userData.birthday).getFullYear();

    // สินทรัพย์สภาพคล่อง
    if (balanceData?.property_asset_list?.length > 0) {
      disabled_asset_all += Number(balanceData?.sum_property_asset || 0);
    }

    // สินทรัพย์ไม่มีตัวตน
    if (balanceData?.property_intangible_list?.length > 0) {
      disabled_asset_all += Number(balanceData?.sum_property_intangible || 0);
    }

    // สินทรัพย์เพื่อการลงทุน (sumCapitalInvest มาจาก property_invest_list จึง gate ไว้)
    if (balanceData?.property_invest_list?.length > 0) {
      disabled_asset_all += sumCapitalInvest(balanceData?.property_invest_list, []);
    }

    // เงินสดเวนคืนกรมธรรม์ประกันชีวิต + อสังหาเพื่อการลงทุน
    // ไม่ได้มาจาก property_invest_list (มาจาก expenses_fixed_list / debt_long_list) → บวกเสมอ ตรงกับ getNetWealth
    disabled_asset_all +=
      SumDebtPersonalValue(balanceData) + sumDebtInvest(balanceData);

    if (balanceData?.salary_peryear_list?.length > 0) {
      for (const salary_peryear_item of balanceData?.salary_peryear_list) {
        disabled_income_salary += defaultValue(
          salary_peryear_item?.salary_permonth,
          0
        );
      }
    }

    if (balanceData?.other_income_list?.length > 0) {
      for (const other_income_item of balanceData?.other_income_list) {
        disabled_income_bonus += defaultValue(
          other_income_item?.other_income_peryear,
          0
        );
      }
    }

    if (balanceData?.interest_peryear_list?.length > 0) {
      for (const interest_peryear_item of balanceData?.interest_peryear_list) {
        disabled_income_bonus += defaultValue(
          interest_peryear_item?.interest_peryear,
          0
        );
      }
    }

    if (balanceData?.expenses_variable_list?.length > 0) {
      for (const expenses_variable_item of balanceData?.expenses_variable_list) {
        if (
          expenses_variable_item.options_expenses_variable === "expenses_tax"
        ) {
          disabled_personal_expenses_tax += expenses_variable_item.pay_peryear;
        }
      }
    }

    if (balanceData?.expenses_fixed_list?.length > 0) {
      for (const expenses_fixed_item of balanceData?.expenses_fixed_list) {
        if (expenses_fixed_item?.expenses_provide_funds?.length > 0) {
          for (const expenses_provide_func_item of expenses_fixed_item.expenses_provide_funds) {
            if (
              expenses_fixed_item.options_expenses_fixed ===
              "expenses_provide_fund"
            ) {
              disabled_personal_expenses_life_fund +=
                expenses_provide_func_item.pay_peryear;
            }
          }
        }
        if (expenses_fixed_item?.expenses_insuarant_socials?.length > 0) {
          for (const expenses_insuarant_socials_item of expenses_fixed_item?.expenses_insuarant_socials) {
            if (
              expenses_fixed_item.options_expenses_fixed ===
              "expenses_insuarant_social"
            ) {
              disabled_personal_expenses_social_insurance +=
                expenses_insuarant_socials_item.pay_peryear;
            }
          }
        }
      }
    }

    localInsuranceData.disabled_income_salary = disabled_income_salary;
    localInsuranceData.disabled_income_bonus = disabled_income_bonus;
    localInsuranceData.disabled_personal_expenses_saving =
      disabled_personal_expenses_saving;
    localInsuranceData.disabled_personal_expenses_tax =
      disabled_personal_expenses_tax;
    localInsuranceData.disabled_personal_expenses_life_fund =
      disabled_personal_expenses_life_fund;
    localInsuranceData.disabled_personal_expenses_social_insurance =
      disabled_personal_expenses_social_insurance;

    // if (!insuranceData?.disabled_current_age) {
    localInsuranceData.disabled_current_age =
      age || retireData?.age_current || 25;
    // }
    // if (!insuranceData?.disabled_dead_age) {
    localInsuranceData.disabled_dead_age = retireData?.age_dead || 90;
    // }
    // if (!insuranceData?.disabled_asset_all) {
    localInsuranceData.disabled_asset_all = disabled_asset_all;
    // }

    localInsuranceData.sum_disabled_insurance_current = Number(
      HealthCheckPDF(balanceData)?.contract_tpd +
        HealthCheckPDF(balanceData)?.aia_mutiplay_ci_more +
        HealthCheckPDF(balanceData)?.aia_total_care_more +
        HealthCheckPDF(balanceData)?.compensation_ecir +
        HealthCheckPDF(balanceData)?.compensation_aia_supercare +
        HealthCheckPDF(balanceData)?.compensation_aia_procare +
        HealthCheckPDF(balanceData)?.compensation_aia_ci_plus_gold +
        HealthCheckPDF(balanceData)?.compensation_aia_ci_plus +
        HealthCheckPDF(balanceData)?.compensation_aia_ci_topup +
        HealthCheckPDF(balanceData)?.compensation_mutiple_care_ci +
        HealthCheckPDF(balanceData)?.critical_illness_insurance_yearly_ci
    );

    setInsuranceData(localInsuranceData);
    setFirstLoading(false);
  }, [balanceData]);

  useEffect(() => {
    if (!firstLoading) {
      onChangeForm("")({
        target: { value: "" },
      });
    }
  }, [firstLoading, reload]);

  const onChangeForm =
    (key, type = "number") =>
    (e) => {
      let value = e.target.value;

      if (type === "number") {
        value = numberWithoutComma(value);
      }

      if (_.isNaN(value)) {
        if (key === "disabled_income_year" || key === "disabled_return_year") {
          value =
            insuranceData?.[key] || insuranceData?.[key] >= 1
              ? insuranceData?.[key]
              : 1;
        }
        value = "";
      }

      const newInsurance = key
        ? { ...insuranceData, [key]: value }
        : { ...insuranceData };
      const keys = Object.keys(newInsurance);
      let sum_disabled_income = 0;
      let sum_disabled_personal_expenses = 0;
      let sum_disabled_family_expenses = 0;
      let sum_disabled_protect = 0;
      let sum_disabled_have_to_money = 0;
      let sum_disabled_return = 0;
      let sum_disabled_remain = 0;
      let sum_disabled_family_five_year = 0;
      let sum_disabled_insurance_net = 0;
      let sum_disabled_insurance_current =
        newInsurance?.sum_disabled_insurance_current;
      let sum_disabled_social_security_fund = 0;
      let sum_disabled_insurance_more = 0;
      let disabled_asset_social_dead_pv = 0;
      let disabled_diff_year = 0;
      let sum_disabled_asset_current = 0;
      let disabled_asset_insurance_private =
        newInsurance?.disabled_asset_insurance_private || 0;

      for (const key of keys) {
        if (
          key.startsWith("disabled_personal_expenses") &&
          key !== "disabled_personal_expenses_saving"
        ) {
          sum_disabled_personal_expenses += defaultValue(newInsurance[key], 0);
        }
      }

      if (newInsurance.disabled_asset_is_social_insurance === "Y") {
        let netIncreaseRate = Math.abs(
          ((1 + newInsurance.disabled_income_year / 100) /
            (1 + newInsurance.disabled_return_year / 100) -
            1) *
            100
        );

        let yearLive =
          Number(newInsurance?.disabled_dead_age || 0) -
          Number(newInsurance?.disabled_current_age || 0);

        newInsurance.disabled_asset_social_dead = PV2(
          netIncreaseRate / 100,
          yearLive,
          90000
        );
      } else {
        newInsurance.disabled_asset_social_dead = 0;
      }

      sum_disabled_social_security_fund +=
        newInsurance.disabled_asset_social_dead;

      newInsurance.disabled_income_salary_per_year =
        defaultValue(newInsurance.disabled_income_salary, 0) * 12;
      sum_disabled_income =
        defaultValue(newInsurance.disabled_income_salary_per_year, 0) 
        // +
        // defaultValue(newInsurance.disabled_income_bonus, 0);

      sum_disabled_family_expenses =
        sum_disabled_income <= 0 || sum_disabled_income < sumEpense
          ? balanceData?.sum_expenses_fixed +
            balanceData?.sum_expenses_variable -
            (newInsurance?.disabled_personal_expenses_tax +
              newInsurance?.disabled_personal_expenses_life_fund +
              newInsurance?.disabled_personal_expenses_social_insurance)
          : defaultValue(sum_disabled_income) -
            (newInsurance?.disabled_personal_expenses_saving +
              newInsurance?.disabled_personal_expenses_tax +
              newInsurance?.disabled_personal_expenses_life_fund +
              newInsurance?.disabled_personal_expenses_social_insurance);
      sum_disabled_family_five_year = sum_disabled_family_expenses;
      sum_disabled_protect =
        sum_disabled_family_expenses *
        (newInsurance.disabled_dead_age - newInsurance.disabled_current_age);
      const diff_rate = calculateRateDifference(
        newInsurance.disabled_return_year,
        newInsurance.disabled_income_year
      );

      disabled_diff_year =
        newInsurance.disabled_dead_age - newInsurance.disabled_current_age;

      sum_disabled_have_to_money = PV2(
        diff_rate / 100,
        disabled_diff_year,
        sum_disabled_family_expenses
      );

      sum_disabled_asset_current = defaultValue(
        newInsurance.disabled_asset_all,
        0
      );

      if (_.isNaN(sum_disabled_have_to_money)) {
        sum_disabled_have_to_money = 0;
      }
      if (_.isNaN(sum_disabled_remain)) {
        sum_disabled_remain = 0;
      }
      if (_.isNaN(sum_disabled_protect)) {
        sum_disabled_protect = 0;
      }
      if (_.isNaN(sum_disabled_return)) {
        sum_disabled_return = 0;
      }

      sum_disabled_insurance_net =
        sum_disabled_have_to_money - sum_disabled_insurance_current;
      sum_disabled_insurance_more =
        sum_disabled_have_to_money - sum_disabled_insurance_current;

      let tempDisabledIncomeYear =
        newInsurance?.disabled_income_year >= 1
          ? newInsurance?.disabled_income_year
          : 1;
      let tempDisabledReturnYear =
        newInsurance?.disabled_return_year >= 1
          ? newInsurance?.disabled_return_year
          : 1;

      let liveYear =
        Number(newInsurance?.disabled_dead_age || 90) -
        Number(newInsurance?.disabled_current_age || 25);

      let netIncomeIncrease = Math.abs(
        ((1 + tempDisabledIncomeYear / 100) /
          (1 + tempDisabledReturnYear / 100) -
          1) *
          100
      );

      disabled_asset_social_dead_pv = PV2(
        netIncomeIncrease / 100,
        liveYear,
        90000
      );

      setInsuranceData({
        ...newInsurance,
        disabled_asset_insurance_private,
        disabled_asset_social_dead_pv,
        disabled_diff_year,
        sum_disabled_income,
        sum_disabled_family_expenses,
        sum_disabled_personal_expenses,
        sum_disabled_protect,
        sum_disabled_have_to_money,
        sum_disabled_return,
        sum_disabled_remain,
        sum_disabled_family_five_year,
        sum_disabled_insurance_net,
        sum_disabled_insurance_current,
        sum_disabled_insurance_more,
        sum_disabled_asset_current,
        sum_disabled_social_security_fund,
      });
    };

  const onChangeAge = (e) => {
    const [current, dead] = e;
    const newInsurance = { ...insuranceData };
    let sum_disabled_protect = 0;
    newInsurance.disabled_current_age = current;
    newInsurance.disabled_dead_age = dead;
    sum_disabled_protect =
      insuranceData.sum_disabled_family_expenses * (dead - current);
    setInsuranceData({ ...newInsurance, sum_disabled_protect });
    setReload((prev) => prev + 1);
  };

  // sum_disabled_have_to_money

  useEffect(() => {
    if (tab === 2) {
      setInsuranceData({
        ...insuranceData,
        disabled_income_year: insuranceData.disabled_income_year || 1,
      });
    }
  }, [tab]);

  return (
    <div>
      <Container>
        <div className=" mb-10">
          <div className={`${STYLE_MARGIN_TOP_PARENT} `}>
            <HeaderTitle
              title="ทุนประกันคุ้มครองกรณีทุพพลภาพ"
              isGoback
              onClickGoBack={() => {
                if (final) {
                  setFinal(false);
                  setTab(2);
                  return;
                }
                navigate("/insuranceplan");
              }}
            />
            {final ? (
              <ViewDisable_Final setFinal={setFinal} setTab={setTab} />
            ) : (
              <>
                <div className={` ${STYLE_PADDING_MAIN}`}>
                  {/* ------ หัวข้อ Step ------ */}
                  <div className=" px-4">
                    <Stepper
                      activeStep={tab}
                      lineClassName="bg-gray-300"
                      activeLineClassName="bg-maincyan"
                      className={`${STYLE_TAB} `}
                      isLastStep={(value) => setIsLastStep(value)}
                      isFirstStep={(value) => setIsFirstStep(value)}
                    >
                      <Step
                        className=" !bg-maincyan text-lg"
                        activeClassName="!bg-maincyan "
                        onClick={() => setTab(0)}
                      >
                        <div className=" mt-0.5">1</div>
                      </Step>
                      <Step
                        onClick={() => setTab(1)}
                        className={`${
                          tab === 0 ? "!bg-gray300" : "!bg-maincyan"
                        }`}
                        activeClassName="!bg-maincyan"
                      >
                        <div className=" mt-0.5">2</div>
                      </Step>

                      <Step
                        className="!bg-gray-300"
                        activeClassName="!bg-maincyan"
                        onClick={() => setTab(2)}
                      >
                        <div className=" mt-0.5">3</div>
                      </Step>
                    </Stepper>
                  </div>
                </div>
                {tab === 0 && (
                  <ViewDisable_StepOne onChangeForm={onChangeForm} />
                )}
                {tab === 1 && (
                  <ViewDisable_StepTwo
                    onChangeForm={onChangeForm}
                    insuranceData={insuranceData}
                  />
                )}
                {tab === 2 && (
                  <ViewDisable_StepThree
                    onChangeForm={onChangeForm}
                    onChangeAge={onChangeAge}
                  />
                )}
                <div className=" flex justify-center gap-4 mb-10 px-5">
                  {tab === 0 ? (
                    <div>
                      <MTButton
                        text={"ถัดไป"}
                        color="bg-maincyan"
                        onClick={(e) => {
                          setTab((prev) => prev + 1);
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <div className=" flex justify-center items-center gap-2">
                        <MTButton
                          // loading={loading}
                          text="ย้อนกลับ"
                          color="border border-maincyan "
                          colortext="text-maincyan group-hover:text-white"
                          hovercolor="hover:bg-maincyan group "
                          onClick={() => {
                            setTab((prev) => prev - 1);
                          }}
                        />
                        <MTButton
                          // loading={loading}
                          text={"ถัดไป"}
                          color="bg-maincyan"
                          onClick={(e) => {
                            if (tab === 2) {
                              setFinal(true);
                              setInsuranceData({
                                ...insuranceData,
                                is_plan: true,
                              });
                              return;
                            }
                            setTab((prev) => prev + 1);
                          }}
                        />
                      </div>
                      {/* )} */}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ViewDisableInsurance;
